import React, { Ref } from "react";
import * as Router from "react-router-dom";
import { urls } from "routes/urls";

interface Props extends Router.LinkProps, Router.RouteComponentProps {
	to: string,
	// NB: must NOT be named `wrappedComponentRef` — react-router v5 `withRouter` intercepts that
	// prop and applies it as the real `ref` on this class, so a caller's ref (e.g. MUI ButtonBase's
	// focus-visible ref) would land on the class instance instead of the anchor DOM node and crash
	// v5's useIsFocusVisible (node.ownerDocument is undefined). A neutral name flows through as a
	// normal prop and reaches the underlying <a> via Router.Link's innerRef.
	forwardedRef: Ref<HTMLAnchorElement>,
}

class Component extends React.Component<Props> {

    render() {
        const { to, forwardedRef, location, staticContext, ...rest } = this.props;
		let path: string | object;
		
        if (location.pathname === to) {
            path = {
                pathname: urls.redirect, 
                state: {
                    path: to,
                },
            }
        } else {
            path = to; 
        }
        return <Router.Link {...rest} innerRef={forwardedRef} to={path}/>;
    }
}

const ComponentWithRouter = Router.withRouter(Component);

export const RouterLinkWrapper = React.forwardRef<HTMLAnchorElement, Partial<Router.LinkProps>>(
	(props, ref) => (
		<ComponentWithRouter to={props.to as any} {...props} forwardedRef={ref} />
	)
)